import React from 'react';
import Sidebar from './Sidebar';

function AppLayout({ children }) {
  return (
    <div className="flex min-h-screen bg-tenq-gray-light">
      <Sidebar />

      {/* Main Content Area - offset for sidebar (collapsed width by default) */}
      <div className="flex-1 md:ml-20 min-h-screen transition-all duration-300 overflow-x-hidden">
        {/* Responsive padding: smaller on mobile, larger on desktop */}
        {/* Safe area padding for notched devices (iPhone X+) */}
        <main className="p-4 sm:p-6 lg:p-8 pb-safe pt-16 lg:pt-4 overflow-x-hidden max-w-full">
          {children}
        </main>
      </div>
    </div>
  );
}

export default AppLayout;
